import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "../../libraries/state_reducers/store";
import {
  appplyActionImage,
  provideFileEdited,
  provideFileString,
} from "../../libraries/state_reducers/service/ImageEditorReducer";
import UtilityHelper from "../utilities/UtilityHelper";
import { removeModal } from "../../libraries/state_reducers/widget/ModalsReducer";
import ModalKeys from "../../const/ModalKeys";
import { ImageCropper } from "./ImageEditor";
import Scaffold from "../../widget/layouts/Scaffold";
import AppTranslation from "../app_translation/AppTranslation";
import ImageEditorActions from "./widget/ImageEditorActions";

const ImageEditorScreen = (props: { screenMobileView: boolean }) => {
  const dispatch = useDispatch();

  const fileStringDetailSelector = useSelector(
    (state: RootState) => state.imageEditor.fileStringDetail
  );

  const [image, setImage] = useState<string | null>(null);
  //const [result, setResult] = useState<string | null>(null);

  const getResult = async (res: string | null) => {
    //setResult(res);
    //console.log(UtilityHelper.base64ToFile(res!, "image.png"));

    dispatch(
      provideFileEdited({
        fileString: res,
        fromAction: fileStringDetailSelector?.fromAction!,
        type: "image",
      })
    );

    await UtilityHelper.delay(500);
    dispatch(removeModal(ModalKeys.image_editor));
  };

  useEffect(() => {
    if (fileStringDetailSelector?.fileString != null) {
      setImage(fileStringDetailSelector?.fileString);
    }

    return () => {
      dispatch(provideFileString(null));
    };
    // eslint-disable-next-line
  }, [fileStringDetailSelector]);

  useEffect(() => {
    return () => {
      dispatch(appplyActionImage(false));
    };
    // eslint-disable-next-line
  }, []);

  const bodyContent: JSX.Element = (
    <div className="h-100 overflow-hidden">
      {image && (
        <ImageCropper
          imageSrc={image}
          onComplete={(cropped) => getResult(cropped)}
        />
      )}

      {/* {result && (
          <div>
            <h3>Cropped Result</h3>
            <img src={result} alt="cropped" style={{ width: 200 }} />
          </div>
        )} */}
    </div>
  );

  return (
    <>
      {props.screenMobileView === true ? (
        <Scaffold
          appBarTitle={AppTranslation.text("crop_image")}
          appBarAction={<ImageEditorActions />}
          isModal={true}
        >
          {bodyContent}
        </Scaffold>
      ) : (
        bodyContent
      )}
    </>
  );
};

export default ImageEditorScreen;
export const routeName: string = "/image-editor";
